import { useEffect } from 'react';
import { staticSidebarDefaultPINFiltersResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/project-filters/index.tsx';
import { useResource } from '@atlassian/react-resource-router';
import type { UseDefaultPinFiltersReturn } from './types.tsx';

export const useDefaultPinFilters = (): UseDefaultPinFiltersReturn => {
	const { data, loading, refresh, error } = useResource(staticSidebarDefaultPINFiltersResource);
	useEffect(() => {
		if (data == null && error == null && loading === false) {
			refresh();
		}
	}, [data, error, loading, refresh]);

	return { data, loading };
};
